import React from 'react';
import V2EnterLayout from './V2EnterLayout';

interface V2CheckoutAndIdentityProps {}

const Login = () => (
  <div>
    V2
    <br />
    LOGIN
  </div>
);
const Checkout = () => (
  <div>
    V2
    <br />
    CHECKOUT
  </div>
);
const SummaryArea = () => (
  <div>
    V2
    <br />
    SUMMARY AREA
  </div>
);

export const V2CheckoutAndIdentity: React.FC<
  V2CheckoutAndIdentityProps
> = ({}) => {
  return (
    <V2EnterLayout
      desktopLeft={
        <>
          <Login />
          <Checkout />
        </>
      }
      desktopRight={
        <>
          <SummaryArea />
        </>
      }
      mobileTop={
        <>
          <SummaryArea />
        </>
      }
      mobileBottom={
        <>
          <Login />
          <Checkout />
        </>
      }
    />
  );
};

export default V2CheckoutAndIdentity;
